import React from 'react';

const generateArrModal = ({ title }) => ({
  title,
  body: (
    <div>
      <p>
        The arrival time is the universal coordinated time of the arrival of the initial tsunami wave at the location of the effects given in Day, Hour and Minutes.
      </p>
    </div>
  ),
});

export const RuArrDayModal = generateArrModal({ title: 'Initial Wave Arrival Time - Day' });
export const RuArrHourModal = generateArrModal({ title: 'Initial Wave Arrival Time - Hour' });
export const RuArrMinuteModal = generateArrModal({ title: 'Initial Wave Arrival Time - Minutes' });
